import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, toObservable, createDeepSelectorRx, nextToPromise, contains } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { MultiselectorGuiaList } from "app/features/general/operativa/items/ocurre/componentes/multiguias/list";
import * as rx from "rxjs";

const selectorDireccionRx = componentToRx(selectores.DireccionClienteSelector);
type Entity = models.NuevoManifiestoRADModel;
//const resource = resources.ManifiestoRAD;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    session: models.Session;
}

/**
* Valida un NuevoManifiestoRADModel
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        IdDireccionClienteOrigen: validation.required,
        IdSucursal: validation.required,
        FoliosGuias: x => x.FoliosGuias.length == 0 ? "Seleccione por lo menos una guia" : true
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class NuevoManifiestoRADModelFormNoRx extends React.PureComponent<Props> {
    constructor(props) {
        super(props);
        console.log("Construyendo NuevoManifiestoRADModelFormNoRx");
    }

    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    filtroGuias = createSelectorRx(this.value, x => ({
        idDireccionCliente: x.IdDireccionClienteOrigen,
        idSucursalOrigen: x.IdSucursal
    }));

    guias = createDeepSelectorRx(this.filtroGuias, filtro =>
        (filtro.idDireccionCliente && filtro.idSucursalOrigen) ?
            observeResource(resources.ManifiestoRAD.ObtenerGuiasNuevoManifiesto, filtro.idDireccionCliente, filtro.idSucursalOrigen) :
            toObservable([])
    );

    permisosUsuario = (props: Props) => resources.User.PermisoRx;
    permisoVerTodosClientes = createSelectorRx(this.permisosUsuario, permisos => permisos.ManifiestoRAD.AgregarCualquierCliente);
    permisoVerTodasSucursales = createSelectorRx(this.permisosUsuario, permisos => permisos.ManifiestoRAD.AgregarCualquierSucursal);
    filtrarDirecciones = createSelectorRx(this.permisosUsuario, permisos => !permisos.ManifiestoRAD.AgregarCualquierSucursal);

    private session = (props: Props) => props.session;
    private idClienteUsuario = createSelectorRx(this.session, session => (session.IdCliente || undefined));
    private idSucursalUsuario = createSelectorRx(this.session, session => (session.IdSucursal || undefined));
    private idDireccionUsuario = createSelectorRx(this.session, session => (session.IdDireccionOrigen || undefined));


    tieneCliente = createSelectorRx(this.idClienteUsuario, (idCliente) => idCliente != undefined);

    idCliente = createSelectorRx(this.permisoVerTodosClientes, this.idClienteUsuario, (permiso, idCliente) => permiso ? undefined : idCliente);
    idSucursal = createSelectorRx(this.permisoVerTodasSucursales, this.idSucursalUsuario, (permiso, idSucursal) => permiso ? undefined : idSucursal);
    filtroCliente = createSelectorRx(this.idCliente, idCliente => ({
        IdRegistro: idCliente,
    } as models.FiltroCliente));

    idDireccionCliente = createSelectorRx(this.value, x => x.IdDireccionClienteOrigen);
    sucursales = createSelectorRx(this.idDireccionCliente, this.idCliente, this.idSucursal, (idDireccion, idCliente, idSucursal) => {
        return observeResource(resources.Sucursal.query, {
            IdDireccionCliente: idDireccion,
            IdCliente: idCliente,
            IdRegistro: idSucursal
        })
    });

    choferes = createSelectorRx(this.idDireccionCliente, this.idCliente, this.idSucursal, (idDireccion, idCliente, idSucursal) => {
        return observeResource(resources.Sucursal.BySucursal, {
            IdDireccionCliente: idDireccion,
            IdCliente: idCliente,
            IdRegistro: idSucursal
        })
    });

    onTodas = async () => {
        const guias = await nextToPromise(this.guias(this.props));
        this.props.onChange({ ... this.props.value, FoliosGuias: guias.map(y => y.Folio) });
    }
    onNinguna = async () => {
        this.props.onChange({ ... this.props.value, FoliosGuias: [] });
    }

    render() {
        const { value, onGuardar } = this.props;
        const getField = this.getField;

        const idCliente = this.idCliente(this.props);
        const tieneCliente = this.tieneCliente(this.props);
        const idSucursal = this.idSucursal(this.props);
        const filtrarDirecciones = this.filtrarDirecciones(this.props);

        const filtroCliente = this.filtroCliente(this.props);

        const hasError = this.hasError(this.props);
        //const Sucursal = getField(selectores.Sucursal);
        const Sucursal = getField(SucursalCustomSelector);
        const DireccionCliente = getField(selectorDireccionRx);

        const guias = this.guias(this.props);
        const Multiguias = getField(MultiselectorGuiaList);
        const sucursales = this.sucursales(this.props)
        

        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);

        
        const ValidarSucursal = value.IdSucursal === undefined || value.IdSucursal == null? 0 : value.IdSucursal
        const ChoferEAD = getField(selectores.ChoferEADBySucursal( ValidarSucursal ));
        const CamionEAD = getField(selectores.CamionEADBySucursal( ValidarSucursal ));


        return (
            <div>
                <kea.Title titulo="Nuevo manifiesto de recolección a domicilio" onRegresar={() => history.go("../")} />
                <DireccionCliente
                    field="IdDireccionClienteOrigen"
                    label="Dirección de origen"
                    filtroCliente={filtroCliente}
                    idSucursalUsuario={idSucursal}
                    idDireccionUsuario={this.idDireccionUsuario(this.props)}
                    idCliente={idCliente}
                    seleccionAutomatica={true}
                    filtrarDireccionesPermiso={filtrarDirecciones} />

                <Sucursal field="IdSucursal" items={sucursales} tieneCliente={tieneCliente} />
                <CamionEAD field="IdCamion" label="Camion" />

                <ChoferEAD field="IdChofer" label="Chofer" />


                <div className="btn-group">
                    <kea.Button onClick={this.onTodas} >
                        Todas
                    </kea.Button>
                    <kea.Button onClick={this.onNinguna} >
                        Ninguna
                    </kea.Button>
                </div>

                <Multiguias field="FoliosGuias" items={guias} label="Guias" />

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const NuevoManifiestoRADForm = componentToRx(NuevoManifiestoRADModelFormNoRx);

interface PropsSelector {
    value: number;
    onChange: (value: number) => PromiseLike<void> | void;
    items: models.SucursalDTO[];
    itemsChofer: models.ChoferEADDto[];
    itemsCamion: models.CamionEADDto[];
    tieneCliente: boolean;
}


class SucursalCustomSelectorNoRX extends React.PureComponent<PropsSelector> {
    value = (props: PropsSelector) => props.value;
    getField = formfields(() => this.props);
    sucursales = (props: PropsSelector) => props.items;

    componentDidMount() {
        debugger;
        const sucursales = this.props.items;
        if (!this.props.value && sucursales.length > 0 && this.props.tieneCliente) {
            var nuevoValor = sucursales[0].IdRegistro;
            this.props.onChange(nuevoValor);
        }
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;
        const sucursales = this.sucursales(this.props)
        return (
            <selectores.Sucursal value={value} onChange={this.props.onChange} label="Sucursal" items={sucursales} />
        )
    }
}

class ChoferCustomSelectorNoRX extends React.PureComponent<PropsSelector> {
    value = (props: PropsSelector) => props.value;
    getField = formfields(() => this.props);
    debugger;
    choferes = (props: PropsSelector) => props.itemsChofer;

    componentDidMount() {
        debugger;
        const choferes = this.props.itemsChofer;
        if (!this.props.value && choferes.length > 0 && this.props.tieneCliente) {
            var nuevoValor = choferes[0].IdRegistro;
            this.props.onChange(nuevoValor);
        }
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;
        const choferes = this.choferes(this.props)
        return (
            <selectores.ChoferEAD value={value} onChange={this.props.onChange} label="Chofer" items={choferes} />
        )
    }
}

export const SucursalCustomSelector = componentToRx(SucursalCustomSelectorNoRX);
export const ChoferCustomSelector = componentToRx(ChoferCustomSelectorNoRX);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/manifiestorad/nuevo/form.tsx